export default {
  get_country: state => {return state.country},
  get_tcsoc: state => {return state.tcsoc},
  get_tnocl: state => {return state.tnocl},
  get_tclang: state => {return state.tclang},
  get_tnom: state => {return state.tnom},
  get_tadr1l: state => {return state.tadr1l},
  get_tadr2l: state => {return state.tadr2l},
  get_tadr3l: state => {return state.tadr3l},
  get_tcpostl: state => {return state.tcpostl},
  get_tvillel: state => {return state.tvillel},
  get_tcpaysl: state => {return state.tcpaysl},
  get_tcprovl: state => {return state.tcprovl},
  get_tadr1f: state => {return state.tadr1f},
  get_tadr2f: state => {return state.tadr2f},
  get_tadr3f: state => {return state.tadr3f},
  get_tcpostf: state => {return state.tcpostf},
  get_tvillef: state => {return state.tvillef},
  get_tcpaysf: state => {return state.tcpaysf},
  get_tcprovf: state => {return state.tcprovf},
  get_ttel: state => {return state.ttel},
  get_tcdiv: state => {return state.tcdiv},
  get_tcsdiv: state => {return state.tcsdiv},
  get_tccom: state => {return state.tccom},
  get_tcdev: state => {return state.tcdev},
  get_tsiret: state => {return state.tsiret},
  get_ttvacee: state => {return state.ttvacee},
  get_tweb: state => {return state.tweb},
  get_tnomc: state => {return state.tnomc},
  get_tpnomc: state => {return state.tpnomc},
  get_tmailc: state => {return state.tmailc},
  
  get_pmdp: state => {return state.pmdp},
  get_pmdp_confirm: state => {return state.pmdp_confirm}


};